/*-----------------------------------------------------------------
- Auth configs
-----------------------------------------------------------------*/

export default {
    register: {
        role: 'customer',
    },
};
